export enum LocationTypeEnum {
  City = 'city',
  County = 'county',
  Town = 'town',
  Department = 'department'
}
